<template>
    <div class="row">
        <div class="col-md-12">
            <div v-if="!hasCurrentSubscriptions" class="no-subs panel panel-group panel-transparent">
                <lps-subscription></lps-subscription>
                <hr>
            </div>

            <h4 v-if="sortedSubscriptions.length == 0">Aucune adhésion pour ce client</h4>

            <subscription-item v-else v-for="lps in sortedSubscriptions"
                :lps="lps"
                :key="lps.id"
                :parent-id="'accordion'"
                class="loyalty-program col-md-12 panel panel-group panel-transparent"
                data-toggle="collapse"
                id="accordion">
            </subscription-item>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

import SubscriptionItem from './LoyaltyProgram/SubscriptionItem'
import LpsSubscription from './LoyaltyProgram/LpsSubscription'

export default {
    name: "Fidelite",

    components: {
        SubscriptionItem,
        LpsSubscription
    },

    created () {
        const params = {
            customer_id: this.$store.state.customer.id,
            programs: [],
            statuses: []
        }
        this.fetchLoyaltyProgramSubscriptions(params)
    },

    computed: {
        ...mapState('customer', ['loyaltyProgramSubscriptions']),

        sortedSubscriptions() {
            return _.sortBy(this.loyaltyProgramSubscriptions, ['status'])
        },

        hasCurrentSubscriptions() {
            return _.filter(this.loyaltyProgramSubscriptions, function(s) {
                return 'terminated' != s.status
            }).length > 0
        }
    },

    methods: {
        ...mapActions('customer', ['fetchLoyaltyProgramSubscriptions']),
    }
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/LoyaltyProgramsSubscriptions.vue